import React from 'react';
import headerImg from '../../../assets/img/service-header.jpeg';
import './Header.scss';

const Header = () => {
    return (
        <div className="service-header">
            <img id='header__background-img' src={headerImg} alt="service-header-image" />
            
            <div className='header__content'>
                <h1 id='header__title'>Services</h1>
            </div>
        </div>
    );
};

export default Header;